module.exports = __webpack_public_path__ + "static/joystream-dao-background-87ec594c834ad26ad7c9462ee615dedf.png";